import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import '../styles/History.css';

const URL_BACKEND = process.env.REACT_APP_URL_BACKEND;

const modes = ['item', 'game', 'character', 'sword'];

const modeFields = {
  item: { idCol: 'id_item', nameCol: 'nom_item' },
  game: { idCol: 'id_jeu', nameCol: 'nom_jeu' },
  character: { idCol: 'id_personnage', nameCol: 'nom_personnage' },
  sword: { idCol: 'id_epee', nameCol: 'nom_epee' },
};

function History() {
  const { t } = useTranslation();
  const { mode } = useParams();
  const [puzzles, setPuzzles] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    setPuzzles(null);
    setError(false);
    fetch(`${URL_BACKEND}/api/history/${mode}`)
      .then(r => {
        if (!r.ok) throw new Error('Not found');
        return r.json();
      })
      .then(data => {
        setPuzzles(data);
      })
      .catch(() => setError(true));
  }, [mode]);

  if (error) return <p>Erreur de chargement de l'historique.</p>;
  if (!puzzles) return null;

  const fields = modeFields[mode];

  return (
    <div className="history">
      <nav className="history-mode-nav">
        {modes.map(m => (
          <Link
            key={m}
            to={`/history/${m}`}
            className={`history-mode-link ${m === mode ? 'active' : ''}`}
          >
            {t(`home.${m}`)}
          </Link>
        ))}
      </nav>
      <h1>{t('history.title', { mode })}</h1>
      {puzzles.length === 0 ? (
        <p>{t('history.no_puzzles')}</p>
      ) : (
        <ul>
          {puzzles.map(puzzle => {
            // On récupère les informations de solved pour ce puzzle depuis le localStorage
            const solvedArchives = JSON.parse(localStorage.getItem('solved-archive') || '{}')[mode] || {};
            // console.log('solvedArchives:', solvedArchives);
            
            // On récupère les informations de solved pour ce puzzle depuis le localStorage
            const solvedArchiveValues = solvedArchives[puzzle.id_historique];
            //console.log('solvedArchiveValues:', solvedArchiveValues);

            // Déterminer la classe CSS en fonction de l'état de solved
            const classNameText =
              !solvedArchiveValues ? '' :
                solvedArchiveValues?.solved === 0 ? 'loose' : 'won';

            return (
              <li
                key={`${puzzle[fields.idCol]}-${puzzle.id_historique}`}
                className={classNameText}
              >
                <Link to={`/${mode}/${puzzle.id_historique}`}>
                  {puzzle.date_historique}
                </Link>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}

export default History;